import { useEffect, useRef } from 'react';

/**
 * Calls a callback function when the component is unmounted.
 *
 * This hook is useful for performing cleanup tasks, such as removing event listeners or disposing of resources.
 * It is always fired without caring if any dependencies have changed, so be aware of possible infinite renders.
 *
 * @param callback The callback function to be called when the component is unmounted.
 *
 * @example Used by text and table widgets to save when they are unmounted from the DOM when a page changes without triggering onBlur.
 */
export const useUnmountCallback = (callback: Function) => {
  const useRefCallback = useRef<Function>();
  useRefCallback.current = callback;
  useEffect(() => {
    return () => {
      if (useRefCallback.current) {
        useRefCallback.current();
      }
    };
  }, []);
};
